import React from 'react';
import PropTypes from "prop-types";
import { Link, useLocation } from 'react-router-dom';

const Footer = (props) => {
  const { withcookieData } = props;
  const location = useLocation();
  
  // 메뉴 데이터 가져오기
  const menuData = withcookieData?.skin?.menuJsonNonUser || {};
  const mainMenus = Array.isArray(menuData.main_menus) ? menuData.main_menus : [];
  
  // 현재 활성 메뉴 확인
  const isActive = (path) => {
    return location.pathname === path || 
           (path !== '/' && location.pathname.startsWith(path));
  };
  
  // 메인 메뉴 중 최상위 메뉴 5개 선택 (하단 네비게이션용)
  const bottomMenus = mainMenus
    .filter(menu => !menu.parentId) // 최상위 메뉴만 선택
    .slice(0, 5); // 최대 5개만 사용
  
  // 아이콘 매핑 - 메뉴 이름에 따라 적절한 아이콘 설정
  const getIconName = (menu) => {
    const name = menu.name.toLowerCase();
    
    if (menu.icon) return menu.icon;
    
    // 이름에 따른 아이콘 매핑
    if (name.includes('홈') || name.includes('메인')) return 'home-outline';
    if (name.includes('설정')) return 'settings-outline';
    if (name.includes('알림')) return 'notifications-outline';
    if (name.includes('카드')) return 'card-outline';
    if (name.includes('거래') || name.includes('트랜잭션')) return 'swap-vertical';
    if (name.includes('게시판') || name.includes('문서')) return 'document-text-outline';
    if (name.includes('통계') || name.includes('차트')) return 'pie-chart-outline';
    if (name.includes('컴포넌트')) return 'apps-outline';
    if (name.includes('페이지')) return 'layers-outline';
    if (name.includes('프로필')) return 'person-outline';
    
    // 기본 아이콘
    return 'ellipsis-horizontal-outline';
  };
  
  return (
    <>
      {/* App Footer */}
      <div className="appFooter">
        <div className="footer-title">
          {withcookieData?.skin?.copyright || 'Copyright © ' + new Date().getFullYear()}
        </div>
        {withcookieData?.skin?.footer_text || '모바일 금융 애플리케이션 템플릿'}
      </div>
      {/* * App Footer */}
      
      {/* App Bottom Menu */}
      <div className="appBottomMenu">
        {bottomMenus.length > 0 ? (
          // 설정된 메뉴가 있으면 해당 메뉴 사용
          bottomMenus.map((menu, index) => (
            <Link to={menu.path} className={`item ${isActive(menu.path) ? 'active' : ''}`} key={menu.id || index}>
              <div className="col">
                <ion-icon name={getIconName(menu)}></ion-icon>
                <strong>{menu.name}</strong>
              </div>
            </Link>
          ))
        ) : (
          // 기본 메뉴 표시
          <>
            <Link to="/" className={`item ${location.pathname === '/' ? 'active' : ''}`}>
              <div className="col">
                <ion-icon name="pie-chart-outline"></ion-icon>
                <strong>개요</strong>
              </div>
            </Link>
            <Link to="/pages" className={`item ${location.pathname.startsWith('/pages') ? 'active' : ''}`}>
              <div className="col">
                <ion-icon name="document-text-outline"></ion-icon>
                <strong>페이지</strong>
              </div>
            </Link>
            <Link to="/components" className={`item ${location.pathname.startsWith('/components') ? 'active' : ''}`}>
              <div className="col">
                <ion-icon name="apps-outline"></ion-icon>
                <strong>컴포넌트</strong>
              </div>
            </Link>
            <Link to="/cards" className={`item ${location.pathname.startsWith('/cards') ? 'active' : ''}`}>
              <div className="col">
                <ion-icon name="card-outline"></ion-icon>
                <strong>카드</strong>
              </div>
            </Link>
            <Link to="/settings" className={`item ${location.pathname.startsWith('/settings') ? 'active' : ''}`}>
              <div className="col">
                <ion-icon name="settings-outline"></ion-icon>
                <strong>설정</strong>
              </div>
            </Link>
          </>
        )}
      </div>
      {/* * App Bottom Menu */}
    </>
  );
};

Footer.propTypes = {
  withcookieData: PropTypes.object
};

export default Footer; 